import React from 'react';

interface LoadingSpinnerProps {
  size?: number; // Size in pixels
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ size = 64 }) => { // Default size 64px (was 32px)
  return (
    <div className="flex items-center justify-center py-12">
      <div 
        className="border-4 border-purple-200 border-t-purple-600 rounded-full animate-spin"
        style={{ width: `${size}px`, height: `${size}px` }}
      ></div>
    </div>
  );
};